import styled from 'styled-components'
import { StyledFormSection } from '../ArbitrationForm.styled'

export const StyledSaleInfoSection = styled(StyledFormSection)`
  .sale-info-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 16px;
    margin-bottom: 16px;
    font-size: 14px;
  }

  .info-item {
    display: grid;
    grid-template-columns: 150px minmax(0, 1fr);
    align-items: start;
    gap: 8px;
    padding: 0px 12px;

    &.full-width {
      grid-column: 1 / -1;
    }
  }

  .info-label {
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.headerFontColor || theme.colors.fontColor || '#555'};
    line-height: 1.4;
  }

  .info-value {
    display: flex;
    align-items: center;
    min-height: 22px;
    padding: 0;
    border: 0;
    background: transparent;
    color: ${({ theme }) => theme.colors.defaultTextColor || theme.colors.fontColor || '#333'};
    font-size: 14px;
    line-height: 1.5;
  }

  .announcements-block {
    display: block;
    max-width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: default;
  }

  .announcements-block {
    max-width: 500px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: default;
  }
`
